<template>
  <section id="footer">
    <footer
      :class="whereAt"
    >
      <nav
        role="navigation"
        class="navigation"
      >
        <a
          href="contact.html"
          class="left footer_contact"
        >
          {{ $t("footer.contact") }}
        </a>
        <!-- <a href="https://www.instagram.com/bestiefyapp/" class="right footer_privacy" target="_blank">Follow <i class="fab fa-instagram" style="font-weight: bold;"></i></a> -->
        <a
          href="privacypolicy.html"
          class="right footer_privacy"
        >
          {{ $t("footer.privacy") }}
        </a>
        <a
          href="about.html"
          class="left footer_about"
        >
          {{ $t("footer.about") }} ©Bestiefy
        </a>
        <div class="fun-container">
          <a class="fun-toggle right footer_disclaimer">
            {{ $t("footer.fun") }}
          </a>
          <div class="fun">
            {{ $t("footer.disclaimer") }}
          </div>
        </div>
      </nav>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'FooterCompo',
  props: { whereAt: String }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
